// src/components/BrandFilter/BrandFilter.js
import React from 'react';
import './BrandFilter.css';

const AVAILABLE_BRANDS = [
  { key: 'Citadel', label: 'Citadel', count: 115 },
  { key: 'Vallejo', label: 'Vallejo', count: 460 },
  { key: 'Army Painter', label: 'Army Painter', count: 105 },
  { key: 'AK Interactive', label: 'AK Interactive', count: 230 },
  { key: 'PRO Acryl', label: 'PRO Acryl', count: 246 }
];

const BrandFilter = ({ selectedBrands, onChange }) => {
  const isAllSelected = selectedBrands.length === AVAILABLE_BRANDS.length;
  const isNoneSelected = selectedBrands.length === 0;

  const handleSelectAll = () => {
    if (isAllSelected) {
      onChange([]); // Deselect all
    } else {
      onChange(AVAILABLE_BRANDS.map(brand => brand.key)); // Select all
    }
  };

  const handleBrandToggle = (brandKey) => {
    if (selectedBrands.includes(brandKey)) {
      onChange(selectedBrands.filter(brand => brand !== brandKey));
    } else {
      onChange([...selectedBrands, brandKey]);
    }
  };

  return (
    <div className="brand-filter">
      <div className="filter-header">
        <label htmlFor="brand-filter-group" className="control-label">
          Paint Brands
        </label>
        <button 
          type="button"
          className="select-all-btn"
          onClick={handleSelectAll}
        >
          {isAllSelected ? 'Deselect All' : 'Select All'}
        </button>
      </div>
      
      <div 
        className="brand-options" 
        role="group" 
        aria-labelledby="brand-filter-group"
        id="brand-filter-group"
      >
        {AVAILABLE_BRANDS.map(brand => (
          <label key={brand.key} className="brand-option">
            <input
              type="checkbox"
              checked={selectedBrands.includes(brand.key)}
              onChange={() => handleBrandToggle(brand.key)}
              className="brand-checkbox"
              aria-describedby={`${brand.key}-description`}
            />
            <span className="brand-label">
              {brand.label}
              <span id={`${brand.key}-description`} className="brand-count">
                ({brand.count} colors)
              </span>
            </span>
          </label>
        ))}
      </div>

      {isNoneSelected && (
        <div className="filter-warning" role="alert" aria-live="polite">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"></path>
            <path d="M12 9v4"></path>
            <path d="m12 17 .01 0"></path>
          </svg>
          No brands selected. All paints will be excluded from results.
        </div>
      )}
    </div>
  );
};

export default BrandFilter;